import {
  flexibleGrid,
  flexibleGridRow,
  flexibleGridColumn, flexibleGridColumnSpan,
} from '@bingads-webui-campaign-react/flexible-grid-styles';
import { commonDoubleListBoxLeanStyle } from '../double-list-box-lean-style';

const pagerStyles = (components, theme) => ({
  '& .dlb-pager-container': {
    padding: 0,

    '& .pager': {
      height: 'auto',
      textAlign: 'unset',
      padding: 0,
      margin: 0,

      '& .pager-page': {
        marginBottom: 8,

        '& span': {
          marginLeft: 6,
          verticalAlign: 'baseline',
        },
      },
    },
  },
  ...components.paginationStyle(theme),
});

export const newAdExtensionsAssociationsContainer = layout => (components, theme = {}) => ({
  // associations editor container
  '& .associations__container': {
    // Common bootstrap layout styles
    // Common panel styles
    '& .panel-body': {
      lineHeight: '19px',
      // marginBottom: 18,
      padding: 0,
    },

    // Common form styles
    '& .form-group': {
      padding: 0,
      margin: 0,
    },

    '& .associations-sub-title': {
      margin: '0 0 10px 0',
      fontSize: '14px',
      fontWeight: 'normal',
    },

    '& .associations': {
      marginBottom: 8,

      '& .extension-editor-dblist-container': {
        margin: 0,

        ...commonDoubleListBoxLeanStyle(theme),

        '& .doubleListBoxLean': {
          '& .layout-columns-container': {
            ...flexibleGrid(),
            '-ms-grid-columns': layout.layoutColumnsContainerGridTemplateColumns,
            gridTemplateColumns: layout.layoutColumnsContainerGridTemplateColumns,
            columnGap: 8,

            // "Maximum selection alert" section
            '& .alerts-section': {
              ...flexibleGridRow(1),
              ...flexibleGridColumn(1),
              ...flexibleGridColumnSpan(2),

              '& > div[data-bind*="showMaximumSelectionAlert"]': {
                marginBottom: 10.5,
              },
            },

            // Available extensions column
            '& .source-items-section': {
              ...flexibleGridRow(2),
              ...flexibleGridColumn(1),

              display: 'flex',
              flexDirection: 'column',
              overflowY: 'hidden',

              '& > .filter-block': {

                '& .dlb-filter-alignPlaceholder': {
                  padding: 0,
                  position: 'relative',

                  '& .searchbox': {

                    '& input.searchbox-input.form-control': {
                      border: `1px solid ${theme.palette.neutralSecondary}`,
                      borderRadius: 0,
                      height: 48,
                      paddingTop: 5,
                      paddingLeft: 48,
                    },

                    '& .form-control-feedback': {
                      position: 'absolute',
                      top: 16,
                      left: 16,
                      right: 'unset',
                      width: 'unset',
                      height: 'unset',
                      lineHeight: '16px',
                      pointerEvents: 'auto',

                      '& .filter_search_icon_small': {
                        display: 'block',
                        fontSize: 16,
                      },
                    },
                  },
                },
              },

              // list
              '& > .list-block': {
                paddingBottom: 8,

                '& .panel-form': {
                  border: `1px solid ${theme.palette.neutralSecondary}`,
                  borderTop: 0,
                  maxHeight: 311,
                  minHeight: 311,
                  overflowY: 'auto',
                  '& .panel-heading': {
                    padding: 0,
                    marginBottom: 0,

                    '& .panel-title': {
                      fontSize: 14,
                      height: 'auto',
                      lineHeight: '36px',
                      marginTop: 'unset',
                      padding: [0, 8],
                    },
                  },

                  '& .panel-body': {
                    marginBottom: 0,
                    display: 'flex',
                    flexDirection: 'column',

                    '& .dlb-source-container': {
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,

                      '& .dlb-selectAll': {
                        padding: [0, 8],

                        '& > span': {
                          minHeight: 36,
                          lineHeight: '36px',
                        },

                        '& .arrow-button.enabled': {
                          float: 'right',
                          marginTop: 8,
                          marginRight: 4,
                        },
                      },

                      '& .dlb-source-list': {
                        flexGrow: 1,
                        outline: 'none',
                        overflowY: 'auto',

                        '& .dlbItem': {
                          padding: '0 8px',

                          '& .dlbItem-actions': {
                            float: 'right',
                            marginTop: 8,

                            '& .dlbItem-customAction, & .arrow-button': {
                              textDecoration: 'none',

                              '&:focus': {
                                outline: 'solid 1px',
                                outlineOffset: 2,
                              },
                            },

                            '& .arrow-button.enabled': {
                              marginLeft: 10,
                            },
                          },

                          '& .dlbItem-content': {
                            minHeight: 36,
                            lineHeight: '36px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',

                            '& .type-bold': {
                              fontWeight: 600,
                            },

                            '& .wordwrap, .itemTemplate-text, .appListItem-text': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            },

                            '& .itemTemplate-text': {
                              padding: '4px 0px 2px 0px',
                              lineHeight: '28px',

                              '& li': {
                                height: 32,
                                lineHeight: '32px',

                                '& a': {
                                  verticalAlign: 'middle',
                                },
                              },
                            },

                            '& .image-adextension-v2-item, & .image-adextension-v1-item': {
                              width: '160px',
                              float: 'left',
                              position: 'relative',
                              marginTop: '10px',
                              '& img': {
                                width: '150px',
                                height: '100px',
                              },
                              '& .overlayText': {
                                lineHeight: 'normal',
                                paddingLeft: '5px',
                                position: 'absolute',
                                bottom: 0,
                                width: '150px',
                                height: '30px',
                                fontSize: '11px',
                                color: '#FFFFFF',
                                opacity: 0.9,
                                background: '#505050',
                              },
                            },
                            '& .image-adextension-v2-text': {
                              float: 'left',
                              lineHeight: 'normal',
                              width: '175px',
                              textOverflow: 'ellipsis',
                              maxWidth: '175px',
                              paddingTop: '20px',
                            },
                          },
                        },

                        '& .k-loading-mask': {
                          display: 'none',
                        },
                      },
                    },
                  },
                },
              },

              // pager
              ...pagerStyles(components, theme),
            },

            // Selected extensions column
            '& .selected-items-section': {
              ...flexibleGridRow(2),
              ...flexibleGridColumn(2),

              marginRight: 0,
              padding: 0,

              // list
              '& .list-block': {
                paddingBottom: 8,

                '& .panel-form': {
                  padding: 0,
                  border: `1px solid ${theme.palette.neutralSecondary}`,
                  minHeight: 359,
                  maxHeight: 359,
                  overflowY: 'auto',
                  '& .panel-heading': {
                    padding: 0,
                    marginBottom: 0,

                    '& .panel-title': {
                      fontSize: 14,
                      height: 'auto',
                      lineHeight: '36px',
                      marginTop: 'unset',
                      padding: [0, 8],
                    },
                  },

                  '& .panel-body': {
                    marginBottom: 0,

                    '& .dlb-selected-container': {
                      display: 'flex',
                      flexDirection: 'column',

                      '& .dlb-deselectAll': {
                        padding: '0 8px',

                        '& .arrow-button.remove': {
                          marginRight: 6,
                          marginLeft: 10,
                          marginTop: 8,
                          float: 'right',
                          padding: 0,
                        },

                        '& > span': {
                          minHeight: 36,
                          lineHeight: '36px',
                        },
                      },

                      '& .dlb-selected-list': {
                        flexGrow: 1,
                        overflowY: 'auto',

                        '& .dlbItem': {
                          padding: [0, 8],

                          '&.k-state-selected a': {
                            color: '#006cbe', // Fixing A11Y contrast issue. Original link color was #0078d4
                          },

                          '& .arrow-button': {
                            textDecoration: 'none',

                            '&:focus': {
                              outline: 'solid 1px',
                              outlineOffset: 2,
                            },
                          },

                          '& .arrow-button.remove': {
                            marginRight: 10,
                            marginTop: 8,
                            float: 'right',
                            padding: 0,
                          },

                          '& .dlbItem-actions': {
                            float: 'right',
                            marginTop: 8,

                            '& .dlbItem-customAction': {
                              textDecoration: 'none',

                              '&:focus': {
                                outline: 'solid 1px',
                                outlineOffset: 2,
                              },
                            },
                          },

                          '& .dlbItem-content': {
                            minHeight: 36,
                            lineHeight: '36px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',

                            '& .type-bold': {
                              fontWeight: 600,
                            },

                            '& .wordwrap, .itemTemplate-text, .appListItem-text': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            },

                            '& .itemTemplate-text': {
                              '& li': {
                                height: 32,
                                lineHeight: '32px',

                                '& a': {
                                  verticalAlign: 'middle',
                                },
                              },
                            },

                            '& .image-adextension-v2-item, & .image-adextension-v1-item': {
                              width: '160px',
                              float: 'left',
                              position: 'relative',
                              marginTop: '10px',
                              '& img': {
                                width: '150px',
                                height: '100px',
                              },
                              '& .overlayText': {
                                lineHeight: 'normal',
                                paddingLeft: '5px',
                                position: 'absolute',
                                bottom: 0,
                                width: '150px',
                                height: '30px',
                                fontSize: '11px',
                                color: '#FFFFFF',
                                opacity: 0.9,
                                background: '#505050',
                              },
                            },
                            '& .image-adextension-v2-text': {
                              float: 'left',
                              lineHeight: 'normal',
                              width: '175px',
                              textOverflow: 'ellipsis',
                              maxWidth: '175px',
                              paddingTop: '20px',
                            },
                          },
                        },

                        '& .k-loading-mask': {
                          display: 'none',
                        },
                      },
                    },
                  },
                },
              },

              // pager
              ...pagerStyles(components, theme),
            },
          },
        },
      },

      '& .create-link-Container': {
        display: 'inline-block',
        margin: '1px',
        '&:focus-within': {
          outline: `1px solid ${theme.palette.neutralSecondary}`,
        },

        '& span': {
          color: theme.palette.themePrimary,
        },

        '& a.btn-create': {

          '&:hover, &:active': {
            textDecoration: 'underline',
          },

          '&:focus': {
            textDecoration: 'none',
          },
        },
      },
    },

    // Save bar
    '& .panel-body .save-bar': {
      paddingTop: 10,
      borderTop: `1px solid ${theme.palette.neutralLight}`,
    },
  },
});
